// extracted by mini-css-extract-plugin
export default {"buttons":"style_buttons__8ux1x","frame":"style_frame__kJ1d+"};